/* Wrapped in an IIFE: this file and aya-collection-load-more.js are injected as
   classic <script defer> tags, so they share one global lexical scope and any
   duplicate top-level name (both once declared `host`) throws
   "Identifier has already been declared" and kills the second script. */
(() => {
  /*
   * Reference-matched desktop filter presentation: first facet group open, the rest
   * collapsed, plus the Reset Filters / All Products pair under the form.
   *
   * Everything here re-resolves the collection root on each run and watches a stable
   * ancestor instead of <results-list>. Horizon swaps that whole element out when a
   * filter or sort is applied, so a reference captured once at load goes stale: the
   * observer ends up bound to a detached node, never fires again, and the controls
   * below stay missing for the rest of the visit.
   */
  const prepareDesktopFilters = () => {
    const collectionRoot = document.querySelector('main[data-template^="collection"] results-list');

    if (!collectionRoot) return;

    const desktopFacets = collectionRoot.querySelector('.facets--vertical:not(.facets--drawer)');

    if (!desktopFacets) return;

    const facetItems = desktopFacets.querySelectorAll('.facets__item');

    facetItems.forEach((item, index) => {
      const details = item.querySelector('details');

      if (!(details instanceof HTMLDetailsElement) || details.dataset.ayaInitialState === 'set') return;

      details.dataset.ayaInitialState = 'set';
      details.open = index === 0;
    });

    const form = desktopFacets.querySelector('.facets__form');

    if (!(form instanceof HTMLFormElement) || form.querySelector('.aya-facets-actions')) return;

    const actions = document.createElement('div');
    actions.className = 'aya-facets-actions';

    const resetLink = document.createElement('a');
    resetLink.className = 'button button-secondary aya-facets-actions__link';
    resetLink.href = form.getAttribute('action') || window.location.pathname;
    resetLink.textContent = 'Reset Filters';

    const allProductsLink = document.createElement('a');
    allProductsLink.className = 'button button-secondary aya-facets-actions__link';
    allProductsLink.href = '/collections/all';
    allProductsLink.textContent = 'All Products';

    actions.append(resetLink, allProductsLink);
    form.append(actions);
  };

  /* Coalesced to one run per batch: the observer below covers the whole collection
     subtree, so a single facet update delivers many records at once.
     Deliberately a timeout rather than requestAnimationFrame — rAF does not fire
     while the tab is hidden or backgrounded, so the previous rAF version silently
     never injected these controls for anyone who opened the collection in a
     background tab or switched away mid-filter, and the pending flag latched on. */
  let pending = false;

  const schedulePreparation = () => {
    if (pending) return;

    pending = true;
    setTimeout(() => {
      pending = false;
      prepareDesktopFilters();
    }, 0);
  };

  schedulePreparation();

  const host = document.querySelector('main[data-template^="collection"]');

  if (host) {
    new MutationObserver(schedulePreparation).observe(host, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedulePreparation);
  }
})();
